// 文章列表
export const getNewsPage = function (params) {
  return this.$http('get', '/api/news/page/portal', params)
}

// 文章详细
export const getNewsDetail = function (params) {
  return this.$http('get', '/api/news/detail/portal', params)
}
